module.exports = __webpack_public_path__ + "img/lqsx_4.ca92638d.svg";